import React, { useEffect, useState } from "react";
import ReactStrapTable from "components/reactStrapTable";
import { cellRendererCheck } from "utils/columns";


import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Nav,
  NavItem,
  Button,
} from "reactstrap";

import EligibilityDrawer from "pages/ClientDashBoard/Components/GridData/GridReports/EligibilityDrawer";
import Drawer from "components/Drawer";
import { ErrorCode } from "react-dropzone";
import ErrorBoundary from "components/ErrorBoundary";
const EligibleRecord = ({ Eligibilitydata, dateRange, planId, groupId,planCode,groupCode, startDate,endDate,rebatechecked }) => {
console.log(Eligibilitydata);
  const [disabledViewButtom, setDisabledViewButtom] = useState(true);
     const [isOpen, setIsOpen] = useState(false);
 
//  const merged= Eligibilitydata?Eligibilitydata?.labels?.map((_, index) => ({
//   labels: Eligibilitydata.labels[index],
//   cardholderID: Eligibilitydata.cardholderID[index],
//   palnGroup: Eligibilitydata.palnGroup[index]
// })):[];

// console.log(merged,"mergerd")
 
// const uniqueLabels = [
//   ...new Set(
//     merged?.map(item => JSON.stringify({ labels: item?.labels, cardholderID: item?.cardholderID }))
//   )
// ].map(str => JSON?.parse(str));

// console.log(uniqueLabels,"lables")

const EligibilityModelColumns = [
  {
    dataField: 'planGroup',
    text: 'Plan Group',
    sort: false,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: true,
    cellRenderer: (row) => cellRendererCheck(row.planGroup),
  },
  {
    dataField: 'labels',
    text: 'Month',
    sort: false,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: true,
    cellRenderer: (row) => cellRendererCheck(row.labels
),
  },
   {
    dataField: 'memberCount',
    text: 'Member Count',
    sort: false,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: true,
    cellRenderer: (row) => cellRendererCheck(row.memberCount),
  },

   

  // ...uniqueLabels.map((labelName) => ({
  //   dataField: labelName?.cardholderID,
  //   text: labelName?.labels,
  //   sort: false,
  //   width: 140,
  //   show: true,
  //   inputType: 'text',
  //   hideColFilter: true,
  //   cellRenderer: (labelName) => cellRendererCheck(labelName?.cardholderID),
  // }))
];

  // useEffect(() => {
    
  //   if (merged && merged.length > 0) {
  //     setDisabledViewButtom(false);
  //   } else {
  //     setDisabledViewButtom(true);
  //   }
  // }, [merged]);
   useEffect(() => {
     if (Eligibilitydata && Eligibilitydata.length > 0) {
       setDisabledViewButtom(false);
     } else {
       setDisabledViewButtom(true);
     }
   }, [Eligibilitydata]);

 const onHandleIsOpen = (hasRefresh)=> {
      
        if (isBoolean(hasRefresh) && hasRefresh) {
            onClose(true);
        }
        setIsOpen(!isOpen)
      }

  const handleProceed = () => {
    setIsOpen(!isOpen);
  };
  

  return (
    <ErrorBoundary>
    <Card className="p-3 h-100">
      <CardHeader className="border-0 bg-white px-0 pt-0">
        <Row className="align-items-center">
          <Col>
            <CardTitle className="f-20 font-weight-500">
         Eligibility 
            </CardTitle>
          </Col>
        </Row>
      </CardHeader>

      <CardBody className="dashboard-chart-body">
        <div
          className={`table-card scroll-table position-relative border-0 rounded pt-0 scroll ${
            Eligibilitydata?.length > 0 ? "fixed-height" : "default"
          }`}
        >
          <ReactStrapTable columns={EligibilityModelColumns} data={Eligibilitydata} />
        </div>
        <div className="view-report">
          <Button
            color="primary"
            className="ms-2"
            onClick={handleProceed}
            style={{ float: "right", marginTop: "26px" }}
            disabled={disabledViewButtom}
          >
            View Report
          </Button>
        </div>
      </CardBody>
    </Card>
      <Drawer
                    direction='end'
                    title='Eligibility'
                    isOpen={isOpen}
                    toggle={handleProceed}
                    size="lg"
                    disabled={disabledViewButtom}
                            
                >
    <EligibilityDrawer  dateRange={dateRange} planId={planId} groupId={groupId} planCode={planCode} groupCode={groupCode}startDate={startDate} endDate={endDate}  onHandleIsOpen={onHandleIsOpen} rebatechecked={rebatechecked}  />
                </Drawer> 
    </ErrorBoundary>
  );
};

export default EligibleRecord;
